import * as HomeyApi from 'homey-api';

const baseUrl = localStorage.getItem('ATHOM_APPS_API_BASEURL');

export const appsAPI = new HomeyApi.AthomAppsAPI({
  baseUrl: baseUrl ?? import.meta.env.VITE_ATHOM_APPS_API_BASEURL,
});
